import React, { useRef, useEffect } from 'react';
var VeltCommentDialogAttachmentButton = function (props) {
    var annotationId = props.annotationId, defaultCondition = props.defaultCondition, inlineCommentSectionMode = props.inlineCommentSectionMode, template = props.template, componentMeta = props.componentMeta, allowedFileTypes = props.allowedFileTypes, onClicked = props.onClicked, onSelectFiles = props.onSelectFiles, children = props.children;
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current) {
            var element_1 = ref.current;
            var handleClicked_1 = function () {
                if (onClicked)
                    onClicked();
            };
            var handleSelectFiles_1 = function (event) {
                if (onSelectFiles)
                    onSelectFiles(event.detail);
            };
            if (onClicked) {
                element_1.addEventListener('clicked', handleClicked_1);
            }
            if (onSelectFiles) {
                element_1.addEventListener('selectFiles', handleSelectFiles_1);
            }
            return function () {
                if (onClicked) {
                    element_1.removeEventListener('clicked', handleClicked_1);
                }
                if (onSelectFiles) {
                    element_1.removeEventListener('selectFiles', handleSelectFiles_1);
                }
            };
        }
    }, [onClicked, onSelectFiles]);
    return (React.createElement("velt-comment-dialog-attachment-button", { ref: ref, "annotation-id": annotationId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "inline-comment-section-mode": [true, false].includes(inlineCommentSectionMode) ? (inlineCommentSectionMode ? 'true' : 'false') : undefined, template: template ? JSON.stringify(template) : undefined, "component-meta": componentMeta ? (typeof componentMeta === 'string' ? componentMeta : JSON.stringify(componentMeta)) : undefined, "allowed-file-types": allowedFileTypes ? (typeof allowedFileTypes === 'string' ? allowedFileTypes : JSON.stringify(allowedFileTypes)) : undefined }, children));
};
export default VeltCommentDialogAttachmentButton;
